import axios from 'axios';
import consts from '../../util/Consts';

let UserData = JSON.parse(sessionStorage.getItem(consts.sessionVariables.UserData));
let token = UserData?.token;

let headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Accept': 'application/json'
}

if(token) headers.Authorization = 'Bearer ' + token;

export const instance = axios.create({
  headers: headers
});

export let actionType = {
  ROUTE_CHANGE: 'ROUTE_CHANGE'
};

export let routeChange = () => {
  return {
    type: actionType.ROUTE_CHANGE
  }
}